import { InjectionToken } from '@angular/core';

export const BRAND_CONFIG = new InjectionToken<BrandConfig>('BRAND_CONFIG');

export interface BrandConfig {
    logoPath: string;
    brandName: string;
    productName: string;
}
